// extracted by mini-css-extract-plugin
module.exports = {"component":"Body-component--9v9k0"};